import { StoreSlice, AnyObject } from '../types';

export declare type IPowerupMetadata = {
  [key: string]: any;
} | null;

export declare interface IPowerupSlice {
  metadataSrc: string | null;
  loadedMetadata: object | null;
  currentCueMetadata: IPowerupMetadata;
  metadataTrack: TextTrack | null;
  metadata: any,
  chapters: any,
  currentVIEConfig: any,
  targetCue: AnyObject | null,
  overridingChapter: any,
  setMetadataSrc: (v: string | null) => void;
  setLoadedMetadata: (v: object | null) => void;
  setCurrentCueMetadata: (v: IPowerupMetadata) => void;
  setMetadataTrack: (v: TextTrack | null) => void;
  setMetadata: (v:any) => void,
  setChapters: (v:any) => void,
  setCurrentVIEConfig: (v:any) => void,
  setTargetCue: (v:AnyObject | null) => void,
  setOverridingChapter: (v: any) => void,
}

const createPowerupSlice: StoreSlice<IPowerupSlice> = (set) => ({
  metadataSrc: null,
  loadedMetadata: null,
  currentCueMetadata: null,
  metadataTrack: null,
  metadata: null,
  chapters: null,
  currentVIEConfig: null,
  targetCue: null,
  overridingChapter: null,
  setMetadataSrc: (v) => set((state) => { state.metadataSrc = v; }),
  setLoadedMetadata: (v) => set((state) => { state.loadedMetadata = v; }),
  setCurrentCueMetadata: (v) => set((state) => { state.currentCueMetadata = v; }),
  setMetadataTrack: (v) => set((state) => { state.metadataTrack = v; }),
  setMetadata: (v) => set((state) => { state.metadata = v; }),
  setChapters: (v) => set((state) => { state.chapters = v; }),
  setCurrentVIEConfig: (v) => set((state) => { state.currentVIEConfig = v; }),
  setTargetCue: (v) => set((state) => { state.targetCue = v; }),
  setOverridingChapter: (v) => set((state) => { state.overridingChapter = v; }),
});

export default createPowerupSlice;
